module.exports = __webpack_public_path__ + "static/media/opossum.df29d99b.png";